import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { TransactionSuccess } from "../../../common";
import { LanguageContext } from "../../../../context/LanguageContext";
import moment from "moment";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BusinessLoader from "../../../common/BusinessLoader";
import { useSnackbar } from "../../../../context/SnackbarContext";
import { useWalletContext } from "../../../../context/WalletContext";
import { useAuthContext } from "../../../../context/AuthContext";
import { handleApi } from "../../../../apis";
import { WALLETRECHARGETRANSACTION } from "../../../../apis/configuration";
import Receipt from "../Receipt";
import { isDemoMode } from "../../../../utils/demoEnviornment";
import { toast } from "react-toastify";
import html2canvas from "html2canvas";
import { ParagraphText } from "../../../../Libraries";
import { DownloadIcon, ShareIcon } from "../../../../assets/icons/icon";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import downloadReceiptStyles from "../DownloadReceiptBtn.module.css";
import UCashTransactionReceipt from "../../../common/UCashTransactionReceipt";
import UCashTransactionSuccess from "../../../common/UCashTransactionSuccess";
import DownloadReceipt from "../../../common/DownloadReceipt";
import { downloadReceiptImage, printWalletReceiptPreview, copyReceiptImage } from "../../../../utils";

const EasyloadTransactionSuccess = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [showReceipt, setShowReceipt] = useState(false);
  const [state, setState] = useState({
    from: "",
    to: "",
    amount: 0,
    date: moment(),
    commission: 0,
  });
  const [isDownloadLoading, setIsDownloadLoading] = useState(false);
  const [isPrintLoading, setIsPrintLoading] = useState(false);
  const [transactionDetail, setTransactionDetail] = useState({});
  const [I18n] = useContext(LanguageContext);
  const navigate = useNavigate();
  const params = useParams();
  const { showSnackbar } = useSnackbar();
  const location = useLocation();
  const receiptRef = useRef();
  const { earnMoney } = useWalletContext();
  const { business } = useAuthContext();
  const Logo = transactionDetail?.logo_link || state.logo || "";

  useEffect(() => {
    fetchWalletRechargeTransaction();
  }, []);

  let timeoutId = null;

  const fetchWalletRechargeTransaction = async () => {
    if (location?.state?.data && location?.state?.transaction) {
      setState({ ...location?.state?.data });
      setTransactionDetail({ ...location?.state?.transaction });
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    try {
      const response = await handleApi(
        WALLETRECHARGETRANSACTION,
        {
          recharge_key: params?.id,
        },
        null,
        navigate,
      );
      if (response?.status === "COMPLETED") {
        setIsLoading(false);
        const transaction = response?.transaction_details || {};
        let icon = (earnMoney?.easyloadPackages?.list || []).find(
          (item) =>
            item.name.toLowerCase() === transaction?.service?.toLowerCase(),
        );
        icon = icon?.logo;
        setTransactionDetail(transaction);
        setState({
          from: `${transaction?.sender_name
            }(****${transaction?.from_account?.slice(-4)})`,
          amount: Math.abs(transaction?.amount),
          to: `${transaction?.customer_name}(****${transaction?.customer.slice(
            -4,
          )})`,
          logo: icon,
          type: transaction?.type,
          date: transaction?.created_at,
          commission: transaction?.commission,
          offer_name: transaction?.offer_name,
        });
        if (timeoutId) {
          clearTimeout(timeoutId); // Clear the timeout if the request was successful
        }
      } else {
        setIsLoading(true);
        timeoutId = setTimeout(fetchWalletRechargeTransaction, 5000);
      }
    } catch (error) {
      if (timeoutId) {
        clearTimeout(timeoutId); // Clear the timeout if the request was successful
      }
      showSnackbar({
        message: error?.response?.data?.message || I18n.error_in_recharge,
        severity: "error",
        icon: "",
      });
      setIsLoading(false);
    }
  };


  // Whole phrase from one key so each language sets its own order ("{name} کو {item}" in Urdu),
  // same as the bill and voucher screens. Direction comes from the template, not dir="auto".
  const easyloadItem =
    transactionDetail?.type === "bundle_recharge" && transactionDetail?.offer_name
      ? transactionDetail?.offer_name
      : I18n.easyload;
  const easyloadTo = (I18n.easyload_to_name || "{item} to {name}").replace("{item}", easyloadItem);
  const [beforeName, afterName = ""] = easyloadTo.split("{name}");
  const subtitleDir = /[\u0600-\u06FF]/.test(I18n.easyload_to_name || "") ? "rtl" : "ltr";
  const successSubtitle = (
    <span
      dir={subtitleDir}
      style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", flexWrap: "wrap", gap: 4 }}
    >
      <span>
        {transactionDetail?.customer_name ? (
          <>
            {beforeName}
            <span className="fontWeight500">{transactionDetail.customer_name}</span>
            {afterName}
          </>
        ) : (
          easyloadItem
        )}
      </span>
      {Logo ? (
        <span style={{
          display: "inline-flex", width: 25, height: 25,
          borderRadius: 6, flexShrink: 0, overflow: "hidden",
          alignItems: "center", justifyContent: "center",
        }}>
          <img src={Logo} alt="" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
        </span>
      ) : null}
      <span className="fontWeight500" dir="ltr">{transactionDetail?.customer}</span>
    </span>
  );

  const handleDownload = () =>
    downloadReceiptImage(receiptRef, {
      setIsDownloadLoading, analyticsEvent: state.offer_name
        ? "w_earn_ep_packages_download"
        : "w_earn_ep_easyload_download",
      fileName: "Rupin Recharge Receipt",
    });

  const handleCopy = () =>
    copyReceiptImage(receiptRef, {
      showSnackbar, I18n, analyticsEvent: state.offer_name
        ? "w_earn_ep_packages_receipt"
        : "w_earn_ep_easyload_receipt",
    });
  const customerName = transactionDetail?.customer_name || "";
  const tid = transactionDetail?.id || params?.id || "";
  const formattedDate = state.date ? moment(state.date).format("D MMMM YYYY, hh:mm A") : "";

  const receiptRows = [
    { label: I18n.by || "By", value: business?.name || "-" },
    { label: I18n.tid, value: tid },
    { label: I18n.date || "Date", value: formattedDate },
    { label: I18n.fee || "Fee", value: transactionDetail?.fee ? `Rs. ${transactionDetail.fee}` : `Rs. 0 (${I18n.free})` },
    { label: I18n.total_amount || "Total amount", value: `Rs. ${state.amount || 0}` },
  ];

  const receiptRecipient = transactionDetail?.customer_name
    ? transactionDetail?.customer_name : "";
  const receiptBankInfo = `${transactionDetail?.service} - ${transactionDetail?.customer}`;

  const handlePrint = () =>
    printWalletReceiptPreview(
      business,
      {
        headerText: `${I18n.easyload_done_with} <strong>${I18n.rupin}</strong>`,
        amount: state.amount,
        recipientName: receiptRecipient,
        bankInfo: receiptBankInfo,
        rows: receiptRows,
      },
      {
        showSnackbar,
        setIsPrintLoading,
        analyticsEvent: state.offer_name
          ? "w_earn_ep_packages_print"
          : "w_earn_ep_easyload_print",
      },
    );

  return (<Fragment>
    {
      showReceipt ? (
        <UCashTransactionReceipt
          amount={state.amount}
          headerText={
            <>
              {I18n.easyload_done_with} < strong > {I18n.rupin}</strong>
            </>
          }
          recipientName={receiptRecipient}
          bankInfo={receiptBankInfo}
          rows={receiptRows}
          onBack={() => setShowReceipt(false)}
          onPrint={handlePrint}
          onCopy={handleCopy}
          packageName={transactionDetail?.offer_name}
          isPrintLoading={isPrintLoading}
        />
      ) : (
        <UCashTransactionSuccess
          subtitle={successSubtitle}
          tid={tid}
          amount={state.amount}
          processingTime={I18n.default_processing_time}
          onViewReceipt={() => setShowReceipt(true)}
          onClose={() => {
            triggerLogEvent(analytics, state.offer_name ? "w_earn_ep_packages_back" : "w_earn_ep_easyload_back");
            navigate("/UCash/EasyloadTransactions");
          }}
          onDownload={handleDownload}
          isDownloadLoading={isDownloadLoading}
          onBack={() => navigate("/UCash/EasyloadTransactions")}
        />
      )}

    <DownloadReceipt
      ref={receiptRef}
      amount={state.amount}
      headerText={I18n.easyload_done_with_rupin}
      recipientName={receiptRecipient}
      bankInfo=""
      rows={receiptRows}
    />
  </Fragment >
  );
};

export default EasyloadTransactionSuccess;
